import type { SVGProps } from "react";

/**
 * Line-style Instagram glyph used across onboarding, settings/connections,
 * and customer details. Centralized so stroke/size/color stay consistent.
 */
const InstagramIcon = ({
  className,
  strokeWidth = 1.5,
  ...props
}: SVGProps<SVGSVGElement> & { className?: string }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden
    {...props}
  >
    <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
    <circle cx="12" cy="12" r="5" />
    <circle cx="17.5" cy="6.5" r="1" />
  </svg>
);

export default InstagramIcon;
